/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Business_Benefit_Account_DescriptionInputs */

const en_business_benefit_account_description = /** @type {(inputs: Business_Benefit_Account_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dedicated account manager for your organization`)
};

const es_business_benefit_account_description = /** @type {(inputs: Business_Benefit_Account_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gerente de cuenta dedicado para tu organización`)
};

/**
* | output |
* | --- |
* | "Dedicated account manager for your organization" |
*
* @param {Business_Benefit_Account_DescriptionInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const business_benefit_account_description = /** @type {((inputs?: Business_Benefit_Account_DescriptionInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Business_Benefit_Account_DescriptionInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_business_benefit_account_description(inputs)
	return en_business_benefit_account_description(inputs)
});